<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense>
						<v-col cols="2">
							<v-select :items="selectShopList" v-model="query.shopId" item-text="shopName"
								item-value="id" label="校区" dense outlined @change="queryShopChanged" clearable></v-select>
						</v-col>
						<v-col cols="2">
							<v-select :items="selectClassList" v-model="query.classId" item-text="className"
								item-value="id" label="班级" dense outlined clearable></v-select>
						</v-col>
						<v-col cols="1">
							<v-text-field v-model="query.studentNo" label="学员学号" dense outlined></v-text-field>
						</v-col>
						<v-col cols="1">
							<v-text-field v-model="query.studentName" label="学员姓名" dense outlined></v-text-field>
						</v-col>
						<v-col cols="1">
							<v-select :items="statusItems" v-model="query.status" item-text="statusName"
								item-value="id" label="状态" dense outlined></v-select>
						</v-col>
						<v-col cols="1">
							<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
								transition="scale-transition" offset-y
								min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.start" label="创建开始日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined></v-text-field>
								</template>
								<v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn">
								</v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="1">
							<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
								transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.end" label="创建结束日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined></v-text-field>
								</template>
								<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn">
									
								</v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="2">
							<v-btn @click="getTableDataList" color="primary">查询</v-btn>
						</v-col>
						<v-col cols="12">
							<v-btn small @click="showAddDialog" color="info">添加班级学员</v-btn>
						</v-col>
					</v-row>
				</template>
				<template v-slot:item.status="{item}">
					<v-chip small :color="statusColor(item.status)">{{ statusName(item.status) }}
					</v-chip>
				</template>
				<template v-slot:item.studentAvatar="{item}">
					<v-avatar rounded class="my-1">
						<v-img v-if="item.studentAvatar" :src="imgPrev + item.studentAvatar" width="50" height="50"></v-img>
					</v-avatar>
				</template>
				<template v-slot:item.consumeType="{item}">
					<v-chip small :color="consumeTypeColor(item.consumeType)">{{ consumeTypeName(item.consumeType) }}
					</v-chip>
				</template>
				<template v-slot:item.classPrice="{item}">
					{{item.consumeType==='2'?item.classPrice:'-'}}
				</template>

				<template v-slot:item.action="{item}">
					<v-btn  @click.stop="showUpdtePrice(item)" v-if="item.consumeType==='2'" class="mr-3"  color="info" x-small>改价</v-btn>
					<v-btn @click.stop="frozenClassStudent(item)" :disabled="item.status !== '1'" color="error"
						class="mr-3" x-small>作废</v-btn>
					<v-btn @click.stop="freeClassStudent(item)" :disabled="item.status === '1'" color="success"
						x-small>启用</v-btn>

				</template>

			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="2">
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="9" v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>

		<!-- 添加dialog -->
		<v-dialog title="添加班级学员" v-model="add.dialog" max-width="600">
			<v-card>
				<v-card-title>添加班级学员信息</v-card-title>
				<v-card-text>
					<v-row dense>
						<v-col cols="6">
							<v-select :items="selectShopList" v-model="add.classStudent.shopId" @change="addShopChanged"
								item-text="shopName" item-value="id" label="校区" dense outlined></v-select>
						</v-col>
						<v-col cols="6">
							<v-select :items="selectCourseList" v-model="add.classStudent.course" @change="addCourseChanged"
								item-text="courseName" item-value="id" label="课程" return-object dense outlined></v-select>
						</v-col>
						
						<v-col cols="6">
							<v-select :items="selectClassList" v-model="add.classStudent.classId" item-text="className"
								item-value="id" label="班级" dense outlined></v-select>
						</v-col>
						
						<v-col cols="6">
							<v-autocomplete :items="selectStudentList" v-model="add.classStudent.studentId"
							        item-text="studentName" item-value="id"
							        label="学员"  dense outlined @change="addStudentChanged"></v-autocomplete>
						</v-col>
						<v-col cols="6" v-if="add.classStudent.consumeType=='2'">
							<v-text-field v-model="add.classStudent.consumePrice" label="课时单价" 
								dense clearable outlined></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-card outlined v-if="student.id" class="info">
								<v-list-item>
									<v-list-item-avatar size="60" tile>
										<v-avatar v-if="student.avatar" rounded><v-img :src="imgPrev + student.avatar" ></v-img></v-avatar>
									</v-list-item-avatar>
									<v-list-item-content>
										<v-list-item-title class="mb-1 white--text text-body-2">
											姓名：{{student.studentName}}
										</v-list-item-title>
										<v-list-item-subtitle class="mt-1 white--text text-body-2">
											学号：{{student.studentNo}}
										</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-card>
						</v-col>
						
						
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="add.dialog=false">取消</v-btn>
					<v-btn @click="submitAddClassStudent" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- 修改价格dialog -->
		<v-dialog title="修改课时价格" v-model="updatePrice.dialog" max-width="600" persistent>
			<v-card>
				<v-card-title>修改课时价格</v-card-title>
				<v-card-text>
					<v-row class="mb-2 mt-2" rounded>
						<v-col cols="12">
							<v-alert dense type="warning">价格修改后,该课程核销将按新的价格扣费</v-alert>
						</v-col>
					</v-row>
					<v-row dense>
						<v-col cols="8" class="d-flex">
							<v-text-field v-model="updatePrice.classPrice" disabled label="当前课时价格" dense
								outlined></v-text-field>
							<span class="ml-2 mt-2">元/课时</span>
						</v-col>
						<v-col cols="8" class="d-flex" justify="center">
							<v-text-field v-model="updatePrice.newPrice" type="number" label="新课时价格" dense outlined>
							</v-text-field>
							<span class="ml-2 mt-2">元/课时</span>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="updatePrice.dialog=false">取消</v-btn>
					<v-btn @click="submitUpdatePrice" :disabled="updatePrice.submitting" :loading="updatePrice.submitting"
						color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
	import global from '../../../config/global'
	export default {
		name: "class-student-list",
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '教务中心',
						disabled: true
					},
					{
						text: '班级学员管理',
						disabled: true
					},
				],
				imgPrev: global.config.imgPre,
				data: {
					total: 0,
					headers: [
						{
							text: '校区',
							value: 'shopName',
							sortable: false
						},
						{
							text: '课程名称',
							value: 'courseName',
							sortable: false
						},
						{
							text: '班级名称',
							value: 'className',
							sortable: false
						},
						{
							text: '头像',
							value: 'studentAvatar',
							sortable: false
						},
						{
							text: '学员学号',
							value: 'studentNo',
							sortable: false
						},
						{
							text: '学员姓名',
							value: 'studentName',
							sortable: false
						},
						{
							text: '扣费方式',
							value: 'consumeType',
							sortable: false
						},
						{
							text: '课时单价',
							value: 'classPrice',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '操作',
							align: 'left',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				selectShopList: [], //选择门店数据源
				selectCourseList: [], //选择课程数据源
				selectClassList: [], //选择课程数据源
				selectStudentList:[], //选择学生数据源
				statusItems:[
					{id:"",statusName:"全部"},
					{id:"1",statusName:"正常"},
					{id:"0",statusName:"作废"},
				],
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					shopId: "",
					classId: "",
					studentNo: "",
					status:"1",
					studentName:""
				},
				add: {
					dialog: false,
					classStudent: {
						shopId: "",
						course:null,
						classId: "",
						studentId:"",
						consumeType:"",
						consumePrice:"",
					},
				},
				student: {
					id: "",
					studentNo: "",
					studentName: "",
					avatar:""
				},
				updatePrice:{
					dialog:false,
					submiting:false,
					classStudentId:"",
					classPrice:"",
					newPrice:"",
				}

			}
		},
		created() {
			// 获取门店列表
			this.getShopListForSelect();
			this.getTableDataList();
		},
		methods: {
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			consumeTypeName(state){
				let stName = "未知";
				if (state === "1") {
					stName = "按课时扣费";
				} else if (state === "2") {
					stName = "按金额扣费";
				}
				return stName;
			},
			consumeTypeColor(state){
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "2") {
					color = "warning";
				}
				
				return color;
			},
			showUpdtePrice(item){
				this.updatePrice.dialog = true;
				this.updatePrice.classStudentId = item.id;
				this.updatePrice.classPrice = item.classPrice;
				this.updatePrice.newPrice = "";
			},
			submitUpdatePrice() {
				// 提交修改价格
				if (!this.updatePrice.newPrice) {
					that.$noty.error("请输入新的课时价格");
					return
				}
				this.updatePrice.submitting = true;
			
				// api
				const that = this;
				let url = `/edu/class/student/price/update`;
				let postData = {
					classStudentId:this.updatePrice.classStudentId,
					newPrice:this.updatePrice.newPrice
				};
			
				this.axios.post(url, postData).catch(() => {
					that.updatePrice.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.updatePrice.dialog = false;
							that.updatePrice.submitting = false;
							return;
						} else {
							that.updatePrice.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.updatePrice.submitting = false;
						that.$noty.error('网络请求失败');
					}
			
				});
			
			},
			addShopChanged() {
				this.selectCourseList = []; // 清空课程
				this.selectStudentList = []; // 清空学生
				if (this.add.classStudent.shopId) {
					this.getCourseListForSelect(this.add.classStudent.shopId); // 加载校区课程
					
					this.getStudentListForSelect(this.add.classStudent.shopId); // 加载校区学员
					
				}
			},
			addCourseChanged(e){
				
				// 设置扣费方式和默认单价
				this.add.classStudent.consumeType = e.consumeType;
				this.add.classStudent.consumePrice = e.consumePrice;
				
				// 加载课程的班级
				this.selectClassList = [];
				this.getClassListForSelect(e.id); // 加载课程的班级
				
				
			},
			addStudentChanged(e){
				
				//console.log(e);
				
				let studentId = this.add.classStudent.studentId;
				
				console.log("select student id:"+studentId);
				this.clearStudent();
				this.selectStudentList.forEach((item,index)=>{
					if (item.id == studentId){
						this.student = {...item}
					}
				})

			},
			queryShopChanged() {
				this.selectClassList = [];
				this.query.classId = "";
				
				if (this.query.shopId) {
					this.getClassListForSelect(this.query.shopId);
				}
			},
			showAddDialog() {
				this.add.dialog = true;

				// 清空add历史数据
				this.add.classStudent.course = null;
				this.add.classStudent.classId = "";
				this.add.classStudent.shopId = "";
				this.add.classStudent.studentId = "";
				this.add.classStudent.consumeType = "";
				this.add.classStudent.consumePrice = "";
				this.student.id= "";
				
				this.selectCourseList =[];
				this.selectClassList = [];
				this.selectStudentList = [];

			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;


				let url = `/edu/class/student/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.classId) {
					url += "&classId=" + this.query.classId;
				}
				if (this.query.shopId) {
					url += "&shopId=" + this.query.shopId;
				}
				if (this.query.studentNo) {
					url += "&studentNo=" + this.query.studentNo;
				}
				if (this.query.status) {
					url += "&status=" + this.query.status;
				}
				if (this.query.studentName) {
					url += "&studentName=" + this.query.studentName;
				}
				
				this.axios.get(url).then(response => {

					console.log(response);

					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "作废";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			clearStudent(){
				this.student.id = "";
				this.student.avatar = "";
				this.student.studentNo = "";
				this.student.studentName = "";
			},
			submitAddClassStudent() {

				if (!this.add.classStudent.shopId) {
					this.$noty.error('校区不能为空');
					return
				}
				if (!this.add.classStudent.classId) {
					this.$noty.error('班级不能为空');
					return
				}
				if (!this.add.classStudent.studentId) {
					this.$noty.error('学员不能为空');
					return
				}
				
				if (this.add.classStudent.consumeType==='2'){
					if(!this.add.classStudent.consumePrice){
						this.$noty.error('课时单价不能为空');
						return
					}
				}
				
		
				// api
				const that = this;
				let url = `/edu/class/student/create`;
				let postData = {
					shopId:this.add.classStudent.shopId,
					classId:this.add.classStudent.classId,
					studentId: this.student.id,
					consumePrice:this.add.classStudent.consumePrice
				};
				
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.add.dialog = false;
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});
			},
			frozenClassStudent(item) {
				//冻结
				const that = this;
				let url = `/edu/class/student/frozen/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}

				});
			},
			freeClassStudent(item) {
				//冻结
				const that = this;
				let url = `/edu/class/student/free/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}

				});
			},
			getShopListForSelect() {
				const that = this;
				let url = `/sys/merchant/shop/list`;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectShopList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getCourseListForSelect(shopId) {
			
				if (!shopId) {
					return
				}
			
				const that = this;
				let url = `/edu/shop/course/list/` + shopId;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						that.selectCourseList = response.data["data"] ? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getClassListForSelect(courseId) {

				if (!courseId) {
					return
				}

				const that = this;
				let url = `/edu/course/all/class/list/` + courseId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectClassList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getStudentListForSelect(shopId) {
				
				// 获取校区学生列表
				if (!shopId) {
					return
				}
			
				const that = this;
				let url = `/edu/shop/student/list/` + shopId;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						that.selectStudentList = response.data["data"] ? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
			
			getStudentInfo(studentNo) {
				// 获取学生信息
				if (!studentNo) {
					return
				}

				const that = this;
				let url = `/edu/student/info/` + studentNo;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.student = response.data["data"] ? response.data["data"] : [];
						return
					} 

					//that.$noty.error("获取失败：" + response.data["message"]);
				})
			}
		}
	}
</script>

<style>
</style>
